import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["enabled", "href"]




export default /*@__PURE__*/_defineComponent({
  __name: 'AButton',
  props: {
    href: {},
    color: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.href)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        enabled: !__props.disabled,
        class: _normalizeClass(["a-button", { [__props.color]: __props.color, disabled: __props.disabled }]),
        href: __props.href
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["a-button", { [__props.color]: __props.color, disabled: __props.disabled }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
}
}

})